import { useLocation } from 'react-router-dom';

import { SETTINGS_ROUTES } from '@/nav-routes';

export const useMobileRoutesMatch = () => {
  const { pathname } = useLocation();

  const previewPage = pathname?.split('/').includes('preview');
  const tagsPage = pathname?.split('/').includes('tags');

  const allowedRoutes = ['/home', SETTINGS_ROUTES.BASE_ROUTE];

  const navPage = pathname === '/home' || pathname === '/';
  const settingsPage = pathname === SETTINGS_ROUTES.BASE_ROUTE;

  const mobileRoute = allowedRoutes.includes(pathname);

  return {
    mobileRoute,
    allowedRoutes,
    navPage,
    settingsPage,
    previewPage,
    tagsPage,
  };
};
